import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { AppConfig, Module } from '../../shared/models/app.config';

@Injectable()
export class ConfigService {
  config: AppConfig;
  private isConfigServiceLoadedSubject: BehaviorSubject<boolean>;
  public isConfigServiceLoaded: Observable<boolean>;
  private disableEventsSubject: BehaviorSubject<boolean>;
  public disableEvent: Observable<boolean>;
  private addStudentEventsSubject: BehaviorSubject<boolean>;
  public addStudentEvent: Observable<boolean>;

  constructor(private http: HttpClient) {
    this.isConfigServiceLoadedSubject = new BehaviorSubject<boolean>(false);
    this.isConfigServiceLoaded = this.isConfigServiceLoadedSubject.asObservable();
    this.disableEventsSubject = new BehaviorSubject<boolean>(false);
    this.disableEvent = this.disableEventsSubject.asObservable();
    this.addStudentEventsSubject = new BehaviorSubject<boolean>(false);
    this.addStudentEvent = this.addStudentEventsSubject.asObservable();
  }

  get currentUser_env_config() {
    return this.config.currentUser_env;
  }
  get customerServiceapiUri() {
    return this.config.customerServiceinfo;
  }
  get apiUri() {
    return this.config.apiUri;
  }

  get adminApiUri() {
    return this.config.adminApiUrl;
  }

  get insuredApiUri() {
    return this.config.insuredApiUrl;
  }

  get waiverApiUri() {
    return this.config.waiverApiUrl;
  }
  get claimsApiUri() {
    return this.config.claimsApiUrl;
  }
  get supportEmail() {
    return this.config.supportEmail;
  }

  get aboutUs_Guid() {
    return this.config.aboutUs_guid;
  }

  get termsOfUse_content_link() {
    return this.config.termsOfUse_content_link;
  }

  get wPP_content_link() {
    return this.config.wPP_content_link;
  }

  get termsOfUse_Guid() {
    return this.config.termsOfUse_guid;
  }

  get contactUs_Guid() {
    return this.config.contactUs_guid;
  }

  get privacyPolicy_Guid() {
    return this.config.privacyPolicy_guid;
  }

  get additionalBenefitsGuids() {
    return this.config.additionalBenefitsGuids;
  }
  get cmsImageURL() {
    return this.config.cmsImageUrl;
  }

  // Base URL for media served by the premium CMS API (asset GUID is appended).
  get cmsAssetURL() {
    return this.config.cmsAssetUrl;
  }
  get partnerCenterOldUrl() {
    return this.config.partnerCenterOldUrl;
  }

  get srUniteUrl() {
    return this.config.srUniteUrl;
  }

  get menuUrls() {
    return this.config.menuUrls;
  }

  get azmanRoles() {
    return this.config.azmanRoles;
  }

  get modules() {
    return this.config.modules;
  }
  get insuredLabelClientNum() {
    return this.config.insured_Label_ClientNum;
  }
  get forgotPasswordUrl() {
    return this.config.forgotPasswordUrl;
  }

  get forgotUserNameUrl() {
    return this.config.forgotUserNameUrl;
  }

  get idp_AuthorizationUrl() {
    return this.config.idp_AuthorizationUrl;
  }

  get idp_RedirectUrl() {
    return this.config.idp_RedirectUrl;
  }

  get idp_ClientId() {
    return this.config.idp_ClientId;
  }

  get idp_Scope() {
    return this.config.idp_Scope;
  }
  get old_idp_AuthorizationUrl() {
    return this.config.old_idp_AuthorizationUrl;
  }

  get old_idp_ClientId() {
    return this.config.old_idp_ClientId;
  }

  get old_idp_Scope() {
    return this.config.old_idp_Scope;
  }

  get idp_UserInfoUrl() {
    return this.config.idp_UserInfoUrl;
  }

  get idp_PostlogoutRedirectUri() {
    return this.config.idp_PostlogoutRedirectUri;
  }

  get idp_SilentRedirectUri() {
    return this.config.idp_SilentRedirectUri;
  }

  get idp_SilentTimeout() {
    return this.config.idp_SilentTimeout;
  }

  get myaccount_RedirectUri() {
    return this.config.myaccount_RedirectUri;
  }

  get myaccount_idp_scope() {
    return this.config.myaccount_idp_scope;
  }

  get myaccount_cookie_key() {
    return this.config.myaccount_cookie_key;
  }

  get user_Session_Timeout() {
    return this.config.user_Session_Timeout;
  }

  get pc_storage_key() {
    return this.config.pc_storage_key;
  }
  get splunkUrl(): string {
    return this.config.splunkUrl;
  }
  get splunkApplicationName(): string {
    return this.config.splunkApplicationName;
  }
  get currentClientKey() {
    return this.config.currentClientKey;
  }
  get encryptedRolesKey() {
    return this.config.encryptedRolesKey;
  }
  get timeZone(): string {
    return this.config.timeZone;
  }
  get enableDebugSplunkLogging(): string {
    return this.config.enableDebugSplunkLogging;
  }
  get oidcUser(): string {
    return this.config.oidc_user;
  }
  get isUserActiveInPC(): string {
    return this.config.is_User_ActiveInPC;
  }
  get hsid_pfidpadapterid() {
    return this.config.hsid_pfidpadapterid;
  }
  get hsid_client_id() {
    return this.config.hsid_client_id;
  }
  get hsid_myaccount_uri() {
    return this.config.hsid_myaccount_uri;
  }
  get hsid_scope() {
    return this.config.hsid_scope;
  }
  get hsid_portal() {
    return this.config.hsid_portal;
  }
  get myaccount_signout_timeout() {
    return this.config.myaccount_signout_timeout;
  }
  get redirect_to_myaccount_delay() {
    return this.config.redirect_to_myaccount_delay;
  }
  public get hsid_impersonation_url() {
    return this.config.hsid_impersonation_url;
  } setDisableEventsVal(condition: boolean): any {
    this.disableEventsSubject.next(condition);
  }
  public showAddStudent(condition: boolean): any {
    this.addStudentEventsSubject.next(condition);
  }
  public Load(): Promise<AppConfig> {
    return new Promise((resolve) => {
      firstValueFrom<AppConfig>(this.http.get<AppConfig>('assets/app.config.json?rel=v_' + (new Date().getTime())))
        .then((config: AppConfig) => {
          this.copyConfiguration(config, new AppConfig()).then((data: AppConfig) => {
            firstValueFrom<any>(this.http.get<any>('assets/modules.json?rel=v_' + (new Date().getTime())))
              .then((modules) => {
                data.modules = modules;
                data.modules.forEach((module, index) => {
                  data.modules[index] = this.setPermissionString(module, '');
                });
                this.config = data;
                resolve(this.config);
                this.isConfigServiceLoadedSubject.next(true);
              });
          });

        }, (error: any) => {
          this.config = new AppConfig();
          resolve(this.config);
        });
    });
  }

  private setPermissionString(block: Module, parentPermission: string): Module {
    block.permission = (parentPermission ? parentPermission + ' / ' : '') + block.blockName.replace(/ /g, '');
    if (block.blocks && block.blocks.length > 0) {
      block.blocks.forEach((childBlock) => {
        this.setPermissionString(childBlock, block.permission);
      });
    }
    return block;
  }

  private copyConfiguration(source: Object, destination: Object): any {
    return new Promise(function (resolve) {
      Object.keys(source).forEach(function (key) {
        destination[key] = source[key];
        resolve(destination);
      });
    });
  }
}

export function configServiceFactory(config: ConfigService) {
  return () => config.Load();
}
